export {
  useListExtOpsIntegrations,
  listExtOpsIntegrationsQueryKey,
  type CustomIntegration,
  type ExtOpsIntegration,
} from '@omnea-app/fe-organisation-integrations/useListExtOpsIntegrations'
